import styled from 'styled-components';
import { theme } from 'modules/tetrisTheme';
export const DefinitionList = styled.dl `
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.lg};
`;
export const Definition = styled.dd `
  grid-column: 2;
  width: fit-content;
  line-height: ${theme.lineHeight.neutralized};
`;
